












import { Vue, Component, Inject } from "vue-property-decorator";
import { IBasketProviderData } from "@/models/providers/baskets";

@Component({
  components: {
    "basket-item": () =>
      import("@/components/app/global/baskets/basket/basketView/basketItem.vue")
  }
})
export default class BasketItems extends Vue {
  // Inject
  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;
  // Computed
  public get basketProducts() {
    return this.$basketData().basket?.products || [];
  }
}
